import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import SearchField from "../../interface/shared/searchfield";
import Typography from "@mui/material/Typography";
import DashboardLayout from "../layouts/dashboard";
import { ProviderGoodsIn, useGoodsIn } from "../../api/goodsin";
import {
    ProviderExpectedDeliveries,
    useExpectedDeliveriesContext,
} from "../../api/expecteddeliveries";
import Alert from "@mui/material/Alert";
import GoodsInTable from "./components/goods-in-table";
import ExpectedDeliveriesTable from "./components/expected-deliveries-table";


export default function GoodsIn() {
    return (
        <DashboardLayout>
            <ProviderExpectedDeliveries date={new Date()}>
                <ProviderGoodsIn>
                    <GoodsInContent />
                </ProviderGoodsIn>
            </ProviderExpectedDeliveries>
        </DashboardLayout>
    );
}

function GoodsInContent() {
    const { inboundDeliveries, errors, loading, fetchInboundDeliveries, page, perPage, total, setPage, setPerPage, searchTerm, setSearchTerm, sortField, sortOrder, setSort } = useGoodsIn();
    const { expectedDeliveries, loading: expectedDeliveriesLoading } =
        useExpectedDeliveriesContext();

    return (
        <Stack spacing={3} sx={{ px: { xs: 2, md: 4 }, py: 3 }}>
            <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={2}
                alignItems={{ xs: "flex-start", sm: "center" }}
                justifyContent="space-between"
                sx={{ mb: 3 }}
            >
                <Box>
                    <Typography variant="h5" gutterBottom>
                        Goods In
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Recent deliveries processed by the warehouse.
                    </Typography>
                </Box>
                <SearchField
                    placeholder="Search deliveries by VRN or reference"
                    value={searchTerm}
                    onChange={setSearchTerm}
                />
            </Stack>
            {errors.length > 0 && (
                <Alert
                    severity="error"
                    sx={{ mb: 2 }}
                    action={
                        <Button color="inherit" size="small" onClick={fetchInboundDeliveries}>
                            Retry
                        </Button>
                    }
                >
                    {errors.join(" ")}
                </Alert>
            )}
            <GoodsInTable
                loading={loading}
                inboundDeliveries={inboundDeliveries}
                sortField={sortField}
                sortOrder={sortOrder}
                setSort={setSort}
                page={page}
                total={total}
                perPage={perPage}
                setPage={setPage}
                setPerPage={setPerPage}
            />
            <ExpectedDeliveriesTable
                expectedDeliveries={expectedDeliveries}
                loading={expectedDeliveriesLoading}
            />
        </Stack>
    );
}